export interface PurchaseOrderValidationRequestV4 {
  purchaseOrder: string;
  productLine: string;
  jobsiteId: string | number;
}
